<template>
  <v-layout align-center justify-center  pa-5 wrap>
    <v-flex px-2 lg6 md8 xs12>
      <v-layout wrap>
        <TitleDescription :chapterID="$route.params.chapterID"/>
        <pdf-file-input :content="content" />
        <creators-input v-for="type in types" :key="type" :type="type"/>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import PdfFileInput from "./FileInput";
import TitleDescription from "@/components/contents/TitleDescription";
import CreatorsInput from "./CreatorsInput";


export default {
  components: { PdfFileInput, TitleDescription, CreatorsInput },
  props: {
    content: Object
  },

  data: () => ({
    types: ['author', 'reviewer']
  }),
};
</script>

<style scoped>
* {
  transition: all ease-in-out;
}
</style>
